<template>
	<div id="app">
		<div class="container d-flex h-100 flex-column py-2" style="max-width: 100%">
			<div class="row h-100 flex-fill d-flex">
				<div class="col-lg-9 col-sm-8 mb-2" id="router-view">
					<router-view/>
				</div>
				<div class="col-lg-3 col-sm-4 order-sm-first mb-2 d-print-none">
					<list></list>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	import List from './components/List'
	export default {
		components: {List}
	}

</script>

<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
		height: 100%;
	}

	#app > .container > .row > div {
		overflow: scroll;
	}

	@media print {
		#router-view {
			max-width: 100%!important;
			flex: 0 0 100%;
		}

		#app > .container > .row > div {
			overflow: visible;
		}
	}
</style>
